export const GOOGLE_FONT_CATEGORIES = Object.freeze({
  sans: "Modernas",
  serif: "Elegantes",
  display: "Con personalidad",
  handwriting: "Manuscritas",
  monospace: "Monoespaciadas",
});

export const GOOGLE_FONTS = Object.freeze([
  { family: "Asap", category: "sans", recommended: true, weights: [400, 500, 600, 700] },
  { family: "Exo 2", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Inter", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Poppins", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Montserrat", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Roboto", category: "sans", recommended: true, weights: [400, 500, 700, 900] },
  { family: "Open Sans", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Lato", category: "sans", recommended: true, weights: [400, 700, 900] },
  { family: "Raleway", category: "sans", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "DM Sans", category: "sans", recommended: true, weights: [400, 500, 600, 700] },
  { family: "Nunito Sans", category: "sans", recommended: false, weights: [400, 600, 700, 800] },
  { family: "Work Sans", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Manrope", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Rubik", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Ubuntu", category: "sans", recommended: false, weights: [400, 500, 700] },
  { family: "Source Sans 3", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Archivo", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Quicksand", category: "sans", recommended: false, weights: [400, 500, 600, 700] },
  { family: "Outfit", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Plus Jakarta Sans", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Noto Sans", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Merriweather Sans", category: "sans", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Playfair Display", category: "serif", recommended: true, weights: [400, 500, 600, 700, 800] },
  { family: "Lora", category: "serif", recommended: true, weights: [400, 500, 600, 700] },
  { family: "Merriweather", category: "serif", recommended: true, weights: [400, 700, 900] },
  { family: "Cormorant Garamond", category: "serif", recommended: true, weights: [400, 500, 600, 700] },
  { family: "Libre Baskerville", category: "serif", recommended: false, weights: [400, 700] },
  { family: "Crimson Pro", category: "serif", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "EB Garamond", category: "serif", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "Bodoni Moda", category: "serif", recommended: false, weights: [400, 500, 600, 700, 800] },
  { family: "DM Serif Display", category: "serif", recommended: false, weights: [400] },
  { family: "Oswald", category: "display", recommended: true, weights: [400, 500, 600, 700] },
  { family: "Bebas Neue", category: "display", recommended: false, weights: [400] },
  { family: "Dancing Script", category: "handwriting", recommended: false, weights: [400, 500, 600, 700] },
  { family: "Pacifico", category: "handwriting", recommended: false, weights: [400] },
  { family: "Caveat", category: "handwriting", recommended: false, weights: [400, 500, 600, 700] },
  { family: "Great Vibes", category: "handwriting", recommended: false, weights: [400] },
  { family: "Space Mono", category: "monospace", recommended: false, weights: [400, 700] },
]);

export function normalizeGoogleFontFamily(value) {
  return String(value || "")
    .split(",")[0]
    .replace(/["']/g, "")
    .trim();
}

export function findGoogleFont(value) {
  const family = normalizeGoogleFontFamily(value).toLowerCase();
  return GOOGLE_FONTS.find((font) => font.family.toLowerCase() === family) || null;
}

function familyQuery(font, preview = false) {
  const family = font.family.trim().split(/\s+/).join("+");
  const weights = preview
    ? font.weights.filter((weight) => weight === 400 || weight === 700)
    : font.weights;
  const uniqueWeights = [...new Set(weights.length ? weights : [400])].sort((a, b) => a - b);
  return `family=${family}:wght@${uniqueWeights.join(";")}`;
}

export function buildGoogleFontsUrl(...families) {
  const fonts = [];
  families.forEach((value) => {
    const font = findGoogleFont(value);
    if (font && !fonts.some((item) => item.family === font.family)) fonts.push(font);
  });
  if (!fonts.length) return "";
  const query = fonts.map((font) => familyQuery(font)).join("&");
  return `https://fonts.googleapis.com/css2?${query}&display=swap`;
}

export function buildGoogleFontsPreviewUrl() {
  const query = GOOGLE_FONTS.map((font) => familyQuery(font, true)).join("&");
  return `https://fonts.googleapis.com/css2?${query}&display=swap`;
}
